import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';
import { PosPrintDocumentsModalService } from 'src/app/@core/services/pos-print-documents-modal.service';
import { Customer } from 'src/app/models/customer';
import { DigitalSignature } from 'src/app/models/digital-signature';
import { GiftCard } from 'src/app/models/giftcard';
import { Invoice } from 'src/app/models/invoice';
import { OrderCompleteProcess } from 'src/app/models/order-complete-process';
import { Paging } from 'src/app/models/page';
import { Payment } from 'src/app/models/payment';
import { PaymentMethodType } from 'src/app/models/payment-method-type';
import { Receipt } from 'src/app/models/receipt';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CustomerService } from 'src/app/services/customer.service';
import { GiftCardService } from 'src/app/services/giftcard.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { OrderService } from 'src/app/services/order.service';
import { PaymentTypesService } from 'src/app/services/payment-types.service';
import { PaymentsService } from 'src/app/services/payments.service';
import { ReceiptsService } from 'src/app/services/receipts.service';

@Component({
  selector: 'app-giftcard-details',
  templateUrl: './giftcard-details.component.html',
  styleUrls: ['./giftcard-details.component.sass']
})
export class GiftcardDetailsComponent implements OnInit {

  constructor(private giftcardService: GiftCardService, private route: ActivatedRoute, private datePipe: DatePipe, private invoiceService: InvoiceService, private orderService: OrderService, private receiptService: ReceiptsService, private paymentMethodService: PaymentTypesService, private configService: ConfigurationService, private posPrintService: PosPrintDocumentsModalService, private customerService: CustomerService, private paymentsService: PaymentsService, private floatingService: PosFloatingActionButtonService, private router: Router) {

    this.floatingService.setShow(false);
    this.floatingService.addItems();
  }

  giftCard: GiftCard = new GiftCard();
  invoice: Invoice = new Invoice();
  receipt: Receipt = new Receipt();
  payments: Paging<Array<Payment>> = new Paging([]);
  paymentMethods: Array<PaymentMethodType> = [];
  order: OrderCompleteProcess = new OrderCompleteProcess();
  returnOrder: OrderCompleteProcess = new OrderCompleteProcess();
  giftCardMaxAmountPercent: number = 0;
  giftCardMaxAmount: number = 0;
  customer: Customer = new Customer();
  async ngOnInit(): Promise<void> {

    this.paymentMethods = (await this.paymentMethodService.getPaymentMethods(this.configService.readSelectedBranchAndSalesOrg().salesOrg.code).toPromise()).response.content;
    this.giftCard = (await this.giftcardService.readGiftCard(this.route.snapshot.params.code).toPromise()).response;
    if (this.giftCard.invoiceCode) {
      await this.loadFromInvoice();
    }
    if (this.giftCard.creditNoteNumber) {
      await this.loadCreditNoteInformation();
    }
    if (this.giftCard.receiptCode) {
      await this.loadFromReceipt();
    }
    this.customer = await this.customerService.readCustomerByCode(this.order.order.customerCode).toPromise();

    if (this.route.snapshot.queryParams.print) {
      await this.printDocuments();
    }
    if (this.route.snapshot.queryParams.printReturn) {
      await this.printReturnDocuments();
    }
  }

  private async loadFromReceipt() {
    this.receipt = (await this.receiptService.readReceipts({ page: 0, pageSize: 1, value: { code: this.giftCard.receiptCode } }).toPromise()).response.content[0] ?? new Receipt();
    this.payments = (await this.paymentsService.getPayments({ page: 0, pageSize: 1000, value: { groupingNo: this.receipt.groupingNo } }).toPromise()).response;
    this.payments = new Paging(this.payments.content.map(m => {
      m.name = this.getPaymentMethod(m.paymentMethodCode).displayName;
      return m;
    }));
    this.order.receipts.push(this.receipt);
    this.giftCardMaxAmount = this.receipt.details.find(f => f.transactionType.includes(this.giftCard.giftCardNumber))?.totals.netTotal ?? this.giftCard.amount;
    this.giftCardMaxAmountPercent = (this.giftCard.amount / this.giftCardMaxAmount) * 100;
  }

  private async loadCreditNoteInformation() {
    const returnInvoice = (await this.invoiceService.readInvoices({ page: 0, pageSize: 1, value: { fullNumber: this.giftCard.creditNoteNumber } }).toPromise()).response.content[0] ?? new Invoice();
    this.returnOrder = (await this.orderService.readerOrderCompleteProcess(returnInvoice.orderCode).toPromise()).response;
  }

  private async loadFromInvoice() {
    this.invoice = (await this.invoiceService.readInvoices({ page: 0, pageSize: 1, value: { code: this.giftCard.invoiceCode } }).toPromise()).response.content[0] ?? new Invoice();
    this.order = (await this.orderService.readerOrderCompleteProcess(this.invoice.orderCode).toPromise()).response;
    this.payments = new Paging(this.order.payments.map(m => {
      m.name = this.getPaymentMethod(m.paymentMethodCode).displayName;
      return m;
    }));
    this.giftCardMaxAmount = this.invoice.deliveryInvoiceLines.find(f => f.serialNumber == this.giftCard.giftCardNumber)?.totals.netTotal ?? this.giftCard.amount;
    this.giftCardMaxAmountPercent = (this.giftCard.amount / this.giftCardMaxAmount) * 100;
  }

  async printDocuments() {
    await this.posPrintService.show(this.order, this.customer, new DigitalSignature());
  }

  async printReturnDocuments() {
    await this.posPrintService.show(this.returnOrder, this.customer, new DigitalSignature());
  }

  getPaymentMethod(paymentMethodCode: string): PaymentMethodType {
    return this.paymentMethods.find(f => f.code == paymentMethodCode) || new PaymentMethodType();
  }


  getTimeStamp() {
    return this.datePipe.transform(this.giftCard.timestamp, "medium");
  }

  returnGiftcard() {
    this.router.navigate(["giftcards", this.giftCard.giftCardNumber, "return"]);
  }
}
